import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { isNil } from "lodash";

import { FieldType, DateFormats } from "../constants/Date";

dayjs.extend(utc);

// Build a Set for faster key lookup
const fieldTypeKeys = new Set(Object.keys(FieldType));

/**
 * Format a date input (string or Date). Returns "" if invalid.
 */
export const formatDate = (
  dateInput: string | Date,
  outputFormat: string | null = null,
  inputFormat: string | null = null,
  isUTC: boolean | null = null
): string => {
  if (isNil(dateInput)) return "";

  const finalFormat = outputFormat || DateFormats.MM_DD_YYYY_h_mm_a;
  const base =
    dateInput instanceof Date || inputFormat
      ? dateInput
      : new Date(dateInput);

  const factory = isUTC ? dayjs.utc : dayjs;
  const dateObj = inputFormat
    ? factory(base, inputFormat)
    : factory(base as Date);

  return dateObj.isValid() ? dateObj.format(finalFormat) : "";
};

/**
 * @param {any}  restData - A restData any
 *
 * @returns {string} This is the utcdate
 */
/**
 * Recursively normalizes date strings in an object/array:
 * If key is in FieldType and value is a date-like string lacking 'z'/'Z',
 * append 'z' then convert to ISO via dayjs.
 */
export const utcDateToUser = (restData: unknown): unknown => {
  if (Array.isArray(restData)) {
    for (const item of restData) utcDateToUser(item);
    return restData;
  }

  if (restData && typeof restData === "object") {
    for (const key of Object.keys(restData as Record<string, unknown>)) {
      const val = (restData as any)[key];

      if (
        fieldTypeKeys.has(key) &&
        typeof val === "string" &&
        val.length > 0 &&
        !val.toLowerCase().includes("z")
      ) {
        (restData as any)[key] = dayjs(val + "z").toJSON();
      }

      utcDateToUser(val);
    }
  }

  return typeof restData === "object" ? { ...restData } : restData;
};